import ConfigControls , { Controls } from "./Controls";

export default ConfigControls

export {
	Controls,
};
